export const AVATAR_DEFAULT_SIZE = 41;

/**
 * Внутрішня "сітка" дизайну. Ми малюємо у координатах 41×41,
 * а реальний розмір контролюємо через проп `size`.
 */
export const AVATAR_VIEWBOX = "0 0 41 41";
